import React, { useState } from 'react';
import { useNavigate, Link,useLocation } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import logo from '../../assets/logo.png';

const BeforeLoginResetPassword = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const search = useLocation().search;
  const guid = new URLSearchParams(search).get("id");

  const onSubmit = (data) => {
    setIsLoading(true);
  
    const payload = {
      Guid: guid,  // Ensure userID is correctly initialized from the appropriate source
      NewPassword: data.newPassword,
      ConfirmPassword: data.confirmPassword,
    };
    console.log(payload);
  
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/resetpassword`, payload)
      .then(response => {
        setIsLoading(false);
        Swal.fire({
          position: 'center',
          icon: response.data.message === 'Password updated successfully' ? 'success' : 'error',
          title: response.data.message,
          showConfirmButton: false,
          timer: 3000
        });
        if (response.data.message === 'Password updated successfully') {
          navigate("/login");
        }
      })
      .catch(error => {
        setIsLoading(false);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Failed to reset password',
          text: error.response?.data?.message || 'An unexpected error occurred',
          showConfirmButton: true,
        });
        console.error('Error resetting password:', error);
      });
  };
  

  return (
    <>
        <section className="vh-100">
        {isLoading ? <div className="spinner"></div> :
          <>
          <Link to="/Login">
           <img
                  src={logo} style={{ height: '60px',  margin: 15 }} alt="Logo"
                />
                </Link>
 <div className="container h-custom">

  <div className="row d-flex justify-content-center align-items-center mt-4">
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <img
        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
        className="img-fluid"
        alt="Sample" />
    </div>
    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
      <div className="card shadow-lg p-5" style={{ border: 'none' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
      <label className="form-label text-center">Reset Password</label>
                          {/* <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="oldPassword">
                              Old Password
                            </label>
                            <input
                              type="password"
                              id="oldPassword"
                              className={`form-control form-control-lg ${errors.oldPassword ? 'is-invalid' : ''}`}
                              placeholder="Enter old password"
                              {...register('oldPassword', {
                                required: 'Old password is required',
                              })}
                            />
                            {errors.oldPassword && <div className="invalid-feedback">{errors.oldPassword.message}</div>}
                          </div> */}
                          <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="newPassword">
                              New Password
                            </label>
                            <input
                              type="password"
                              id="newPassword"
                              className={`form-control form-control-lg ${errors.newPassword ? 'is-invalid' : ''}`}
                              placeholder="Enter new password"
                              {...register('newPassword', {
                                required: 'New password is required',
                              })}
                            />
                            {errors.newPassword && <div className="invalid-feedback">{errors.newPassword.message}</div>}
                          </div>
                          <div className="form-outline mb-4">
                            <label className="form-label" htmlFor="confirmPassword">
                              Confirm Password
                            </label>
                            <input
                              type="password"
                              id="confirmPassword"
                              className={`form-control form-control-lg ${errors.confirmPassword ? 'is-invalid' : ''}`}
                              placeholder="Confirm new password"
                              {...register('confirmPassword', {
                                required: 'Confirm password is required',
                              })}
                            />
                            {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword.message}</div>}
                          </div>
                          <div className="text-center d-flex justify-content-between text-lg-start mt-4 pt-2">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              disabled={isSubmitting}
                              style={{ backgroundColor: '#2e3192', borderRadius: 8 }}
                            >
                              Submit
                            </button>
                          </div>
                        </form>


      </div>
    </div>
  </div>
</div>

          </>
        }
      </section>
    </>
  );
};

export default BeforeLoginResetPassword;
